/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type ViewInRoomImageCredits_user = {
    readonly " $fragmentRefs": FragmentRefs<"useItemDisplayDimensions_user">;
    readonly " $refType": "ViewInRoomImageCredits_user";
};
export type ViewInRoomImageCredits_user$data = ViewInRoomImageCredits_user;
export type ViewInRoomImageCredits_user$key = {
    readonly " $data"?: ViewInRoomImageCredits_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ViewInRoomImageCredits_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoomImageCredits_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemDisplayDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'b1106e3e53c2bd1432ee2043c5af3c59';
export default node;
